module.exports = __webpack_public_path__ + "img/creditor_1.e678eed6.png";